import React from 'react';
import { TagCollection } from '@fiverr-private/data_display';
import type { Skill } from '../../types';
import { SkillTag } from './SkillTag';

type SkillsProps = Readonly<{
    skills: Skill[];
}>;

export const Skills = ({ skills }: SkillsProps) => (
    <TagCollection>
        {skills.map((skill) => (
            <SkillTag key={skill.id} {...skill} />
        ))}
    </TagCollection>
);
